import React from 'react';
import { graphql } from 'gatsby';

import Layout from '../components/layout/Layout';
import Seo from '../components/seo/Seo';
import ComponentDispatcher from '../components/componentDispatcher/ComponentDispatcher';

import { initialiseTemplate, fetchWebflowRoute } from '../utils';

const Page = ({ data }) => {
  const [source, meta, content, assets, pathName] = initialiseTemplate(data);
  const webflowRoute = fetchWebflowRoute(source);
  const { Title, seoTitle, Description, canonicalUrl, FeatureHeader, PageClass } = meta;
  return (
    <Layout
      bodyClass={`page${FeatureHeader ? ' page--feature-header' : ''} ${PageClass || ''}`}
      Meta={meta}
      fields={data.yaml.fields}
      webflowRoute={webflowRoute}
    >
      <Seo
        pathName={pathName}
        ogImage={meta.ogImage}
        twitterImage={meta.twitterImage}
        title={seoTitle || Title}
        description={Description}
        canonical={canonicalUrl}
      />
      <div className="page__children" id="main-content">
        <ComponentDispatcher {...{ source, meta, content, assets, pathName }} />
      </div>
    </Layout>
  );
};

export default Page;

export const query = graphql`
  fragment YamlMeta on Yaml {
    Meta {
      FeaturedImage {
        publicURL
      }
      Title
      Date
      Description
      NoIndex
      IncludeInSiteMap
      FeatureHeader
      PageClass
      twitterImage
      ogImage
      Author
      seoTitle
      GlossaryTerms {
        term
        link
      }
      SchemaEntities {
        FaqPage {
          questions {
            acceptedAnswer {
              answer
            }
            name
            url
          }
        }
        BreadcrumbList {
          pages {
            name
            url
          }
        }
      }
      Subtitle
      forCampaign
      canonicalUrl
      NavbarCta {
        HideCta
      }
    }
  }

  fragment YamlFields on Yaml {
    fields {
      source
      slug
      layout
    }
  }

  query PageQuery($slug: String, $content: [String], $assets: [String]) {
    yaml(fields: { slug: { eq: $slug } }) {
      ...YamlMeta
      ...YamlFields
    }
    allMarkdownRemark(filter: { fileAbsolutePath: { in: $content } }) {
      edges {
        node {
          html
          fileAbsolutePath
        }
      }
    }
    allFile(filter: { absolutePath: { in: $assets } }) {
      edges {
        node {
          relativePath
          publicURL
        }
      }
    }
  }
`;
